import React, { Component } from 'react';
import { CustomPicker, GithubPicker } from 'react-color';

import { labelColors } from 'app/stores/colors/Colors';
import { HEX_REGEX } from '@kentik/ui-shared/util/regex';
import { findClosestMatch } from '../util/colors';

/* eslint-disable react/prefer-stateless-function */
class ColorPicker extends Component {
  render() {
    const { color, onChange, triangle = undefined, width = 112 } = this.props;

    const colorToMatch = !!color && color.match(HEX_REGEX) ? color : labelColors[0];
    const closestColor = findClosestMatch(colorToMatch, labelColors);

    return (
      <GithubPicker
        width={width}
        style={{ padding: 3, border: 'none', boxShadow: 'none', borderRadius: 0 }}
        onChange={onChange}
        color={closestColor}
        colors={labelColors}
        triangle={triangle}
      />
    );
  }
}

export default CustomPicker(ColorPicker);
